import {
  NEW_USER,
  LOGOUT_USER,
  SET_MONTH_YEAR,
  RESET_MONTH,
  LOAD_STATUS, LOAD_STATUS_SUCCESS, LOAD_STATUS_FAILURE,
} from "../actions/types";
import {endpoints, http} from "../configs/https";
import Swal from "sweetalert2";

const loadStatusRequest = () => {
  return {
    type: LOAD_STATUS,
    isFetching: true,
    data: [],
    message: null,
    failed: false,
  };
};

const month_name = (dt) => {
  var mlist = [
    "",
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];
  return mlist[dt];
}
const loadStatusSuccess = data => {
  return {
    type: LOAD_STATUS_SUCCESS,
    isFetching: false,
    data: data,
    message: null,
    failed: false,
  };
};
const loadStatusFailure = (message) => {
  return {
    type: LOAD_STATUS_FAILURE,
    isFetching: false,
    message: message,
    failed: true,
  };
};

export const createUser = userData => dispatch => {
  dispatch({
    type: NEW_USER,
    payload: userData
  });
};



export const logOutUser = () => dispatch => {
  dispatch({
    type: LOGOUT_USER,
    payload: null
  });
};
export const setMonthYear = monthData => dispatch => {
  monthData.monthName = month_name(monthData.month);
  dispatch({
    type: SET_MONTH_YEAR,
    payload: monthData
  });
};
export const resetMonthYear = () => dispatch => {
  dispatch({
    type: RESET_MONTH,
    payload: null
  });
};

export const loadStatus = (month, year) => dispatch => {
  dispatch(loadStatusRequest());
  http
      .post(endpoints.STATUS, {month: month, year: year})
      .then(response => {
        // this.handleLoginSuccess(response);
        dispatch(loadStatusSuccess(response.data))
      })
      .catch(error => {
        console.log(error);
        let errorMessage =
            (typeof error === "string" && error) ||
            "An error occured, please try again in a moment.";

        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000
        });

        Toast.fire({
          type: "error",
          title: errorMessage
        });
        // alert(JSON.stringify(error));
        console.log(errorMessage);
        dispatch(loadStatusFailure(errorMessage));
      });
};
